export default "__VITE_ASSET__Du22P71A__"